import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const membersSlice = createSlice({
    name: "teamMembers",
    initialState,
    reducers: {},
});

export const {} = membersSlice.actions;
export default membersSlice.reducer;
